<template>
  <div class="login-container">
    <h2>Login</h2>
    <form @submit.prevent="login">
      <input v-model="username" placeholder="Username" required />
      <input v-model="password" type="password" placeholder="Password" required />
      <button type="submit">Login</button>
      <div v-if="error" class="error">{{ error }}</div>
    </form>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';

const username = ref('');
const password = ref('');
const error = ref('');
const router = useRouter();

function login() {
  if (username.value === 'unison' && password.value === 'Unison_1993') {
    // Store login with 1-day expiry
    const expiry = Date.now() + 24 * 60 * 60 * 1000;
    localStorage.setItem('mra_auth', JSON.stringify({ expiry }));
    router.replace('/finished-goods-analysis');
  } else {
    error.value = 'Invalid username or password';
  }
}
</script>

<style scoped>
.login-container {
  max-width: 320px;
  margin: 120px auto;
  padding: 24px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background: #fff;
}
input {
  display: block;
  width: 100%;
  margin-bottom: 12px;
  padding: 8px;
}
button {
  width: 100%;
  padding: 8px;
}
.error {
  color: red;
  margin-top: 8px;
}
</style>